import React, { Fragment } from 'react'
import { Pill, Note } from '@myxplor/ui'
import DisplayWeeklySessions, { extractSessions } from './display-sessions'

const warnings = ['DISPTA', 'DISPTB', 'MANUAL', 'NOTAPP', 'WITHDR', 'WITHDRAWN', 'WITNAP']

const recordIsWarning = ({ status }) => warnings.includes(status.toUpperCase())
const is204cDue = ({gov_record}) => gov_record.responseDueDate204C != null && gov_record.responseDueDate204C !== '0000-00-00'

export const SessionBadges = ({ record }) => {
  const sessions = extractSessions(record)

  return (
    <Fragment>
      <h4>ID: {record.ccs_enrolment_id}&nbsp;</h4>
      <ul>
        {record.status != null &&
          <li>
            <Pill error={recordIsWarning(record)}>{record.status}</Pill>
          </li>
        }
        {is204cDue(record) &&
          <li>
            <Pill error={true}>Action Required (204c) {record.gov_record.responseDueDate204C}</Pill>
          </li>
        }
      </ul>

      {is204cDue(record) &&
        <Note important>This session report must be varied or withdrawn in response to a 204C notice.  For more information regarding this notice, please contact the Department of Education.</Note>
      }
      <div className="enrolment-schedule__wrapper">
        <DisplayWeeklySessions sessions={sessions} />
      </div>
    </Fragment>
  )
}



// WEBPACK FOOTER //
// ./src/session-summaries/details/views/badges.jsx